import React, { useState, useEffect } from 'react';
import { Icon } from '../../Atoms';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';

export default function OrganismFooter(props) {
  const location = useLocation();
  const sideBar = useSelector((state) => state.sideBar);
  const tuto = useSelector((state) => state.tuto);
  const [selectedPath, setSelectedPath] = useState('');
  function getFooterClassName() {
    const className = ['container-footer'];
    if (sideBar.open == true) {
      className.push('container-footer-mobile-open');
    }
    if (tuto.step == 8) {
      className.push('footer-tuto-full-opacity');
    }
    return className.join(' ');
  }
  useEffect(() => {
    const path = location.pathname;
    const aux = path.split('/');
    if (aux.length === 0) {
      setSelectedPath('/');
    } else {
      setSelectedPath(`/${aux[1].toLowerCase()}`);
    }
  }, [location.pathname]);
  return (
    <div className={getFooterClassName()}>
      <div className="container-footer-desktop">
        <div>
          SPVIE Assurances {new Date().getFullYear()} - &nbsp;
          <span>
            <a className='footer-links' href='https://spviepublicassets.blob.core.windows.net/espace-assure/other-documents/Mentions%20l%C3%A9gales-esp%20assur%C3%A9.pdf' target='_blank'>
              Mentions légales
            </a>
            &nbsp; - &nbsp;
          </span>

          <span>
            <a className='footer-links' href='https://spviepublicassets.blob.core.windows.net/espace-assure/other-documents/Mention%20L%C3%A9gales%20-%20SPVIE%20-%20espace%20assur%C3%A9%20VF.pdf' target='_blank'>
              Politique de gestion des données
            </a>
          </span>
        </div>
        {/* <div style={{ margin: '0 4px' }}>-</div> */}
        {/* <div
          style={{ cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }}
          onClick={() => {
            history.push("/termination")
          }}
        >
          Resilier votre contrat
        </div> */}
      </div>
      <div className={'mobile-container-footer-icon'}>
        <Link
          className={
            selectedPath === '/'
              ? 'container-footer-selected-icon'
              : 'container-footer-icon'
          }
          to="/"
        >
          <Icon size={18} icon={'Home'} />
        </Link>
        <Link
          className={
            selectedPath === '/profile'
              ? 'container-footer-selected-icon'
              : 'container-footer-icon'
          }
          to="/Profile"
        >
          <Icon size={18} icon={'Profile'} />
        </Link>
        <Link
          className={
            selectedPath === '/contact'
              ? 'container-footer-selected-icon'
              : 'container-footer-icon'
          }
          to="/Contact"
        >
          <Icon size={18} icon={'Vector10'} />
        </Link>
      </div>
    </div>
  );
}